import React, { useState } from "react";
import AuthForm from "../components/AuthForm";
import InputField from "../components/InputField";
import Button from "../components/Button";
import { Link } from "react-router-dom";
import { showToast } from "../components/ToastNotification";

const PasswordRecovery = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            showToast("Please enter your email address", "error");
            return;
        }

        setLoading(true);
        
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/password-recovery`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                showToast("Password reset link sent! Check your email", "success");
                setEmail(""); // Clear the form
            } else {
                showToast(data.detail || "Failed to send reset email", "error");
            }
        } catch (error) {
            console.error("Password recovery error:", error);
            showToast("Network error. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthForm title="Reset Your Password">
            <form onSubmit={handleSubmit}>
                <InputField
                    label="Email Address"
                    type="email"
                    placeholder="Enter your registered email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <Button 
                    text={loading ? "Sending..." : "Send Reset Link"} 
                    fullWidth 
                    disabled={loading}
                    type="submit"
                />
            </form>
            <p className="mt-4 text-center">
                Remembered your password? <Link to="/auth/signin" className="text-blue-600">Go back to login</Link>
            </p>
        </AuthForm>
    );
};

export default PasswordRecovery;
